import throttle from "lodash/throttle";
//@ts-ignore
import styles from './style.module.css';
import { Editor } from "slate";
import { checkIfInsideTable } from "../../utils";

const OFFSET = 50;
const PX_DIFF = 6;

let scrollIncrement = 0;
let isScrolling = false;
let sidebarElement = null;
let scrollHeightSidebar = 0;
let clientRectBottom = 0;
let clientRectTop = 0;
let previewElement = null;
let previewRef = null;

const goUp = () => {
    scrollIncrement -= PX_DIFF;
    sidebarElement.scrollTop = scrollIncrement;

    if (isScrolling && scrollIncrement >= 0) {
        window.requestAnimationFrame(goUp);
    }
};

const goDown = () => {
    scrollIncrement += PX_DIFF;
    sidebarElement.scrollTop = scrollIncrement;

    if (isScrolling && scrollIncrement <= scrollHeightSidebar) {
        window.requestAnimationFrame(goDown);
    }
};

const onDragOver = event => {

    const isMouseOnTop =
        scrollIncrement >= 0 &&
        event.clientY > clientRectTop &&
        event.clientY < clientRectTop + OFFSET;
    const isMouseOnBottom =
        scrollIncrement <= scrollHeightSidebar &&
        event.clientY > clientRectBottom - OFFSET &&
        event.clientY <= clientRectBottom;

    if (!isScrolling && (isMouseOnTop || isMouseOnBottom)) {
        isScrolling = true;
        scrollIncrement = sidebarElement.scrollTop;

        if (isMouseOnTop) {
            window.requestAnimationFrame(goUp);
        } else {
            window.requestAnimationFrame(goDown);
        }
    } else if (!isMouseOnTop && !isMouseOnBottom) {
        isScrolling = false;
    }
};

const throttleOnDragOver = throttle(onDragOver, 150);

const addEventListenerForSidebar = (elementId, document) => {
    sidebarElement = document.getElementById(elementId);
    scrollHeightSidebar = sidebarElement.scrollHeight;
    const clientRect = sidebarElement.getBoundingClientRect();
    clientRectTop = clientRect.top;
    clientRectBottom = clientRect.bottom;
    sidebarElement.addEventListener("dragover", throttleOnDragOver);
};

const removeEventListenerForSidebar = () => {
    isScrolling = false;

    if (sidebarElement) {
        sidebarElement.removeEventListener("dragover", throttleOnDragOver);
    }
};
const handleMousemove = (event) => {
    previewElement = previewRef.current
    if (previewElement) {
        previewElement.style['display'] = 'block'
        previewElement.style['transform'] = `translate(${event.x + 8}px, calc(${event.y}px - 0.8rem))`
    }
}
const throttleOnMouseMove = handleMousemove;
const addEventListenerForPreview = (previewref, window) => {
    previewRef = previewref
    window.addEventListener("dragover", throttleOnMouseMove)
}
const removeEventListenerForPreview = (window) => {
    window.removeEventListener("dragover", throttleOnMouseMove)
}
export default {
    addEventListenerForSidebar,
    removeEventListenerForSidebar,
    addEventListenerForPreview,
    removeEventListenerForPreview
};


export const getDnDRTLClasses = (props, dndStyles, classesFor: 'container' | 'draggable' ):string  => {
    try {
        const {
            elementtype,
            isNodeRTLDirected,
            editor,
            path
        } = props
        if (!isNodeRTLDirected) return ""
        if (elementtype === 'tr') {
            if (classesFor === 'container') {
                return dndStyles?.['draggable-container-rtl'] ? dndStyles?.['draggable-container-rtl'] : styles?.['draggable-container-rtl']
            } else {
                return dndStyles?.['draggable-rtl'] ? dndStyles?.['draggable-rtl'] : styles?.['draggable-rtl']
            }
        } else if (elementtype === 'li') {
            if (classesFor !== 'draggable') return ""
            if (checkIfInsideTable(editor, path)) {
                return dndStyles?.['draggable-rtl-table-list'] ? dndStyles?.['draggable-rtl-table-list'] : styles?.['draggable-rtl-table-list']
            } else {
                return dndStyles?.['draggable-rtl-list'] ? dndStyles?.['draggable-rtl-list'] : styles?.['draggable-rtl-list']
            }
        }
        return '' 
    } catch (error) {
        console.error(error);
        return '';
    }

}
